import { makeStyles } from '@material-ui/core/styles'

export const useMyMapStyles = makeStyles((theme) => ({
  mapContainer: {
    position: 'relative',
    overflow: 'hidden',
    marginTop: 65,
    marginLeft: 55,
    width: 'calc(100vw - 55px)',
    height: 'calc(100dvh - 65px)',
    [theme.breakpoints.down(770)]: {
      width: '100vw',
      height: 'calc(100dvh - 160px)',
      marginLeft: 0,
      marginTop: 0,
    },
  },
  mapContainerMobilePage: {
    marginLeft: 55,
    width: 'calc(100vw - 55px)',
    height: 'calc(100dvh - 55px)',
    [theme.breakpoints.down(770)]: {
      width: '100vw',
      height: 'calc(100dvh)',
      marginLeft: 0,
      marginTop: 0,
    },
  },
  mapContainerNavOpen: {
    marginLeft: 300,
    width: '100vw',
    height: '100dvh',
    [theme.breakpoints.down(1910)]: {
      marginLeft: 0,
      width: '100vw',
      height: '100dvh',
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: 0,
      width: '100vw',
      height: 'calc(100dvh - 103px)',
    },
  },
}))

export default useMyMapStyles
